import { createContext, useState } from 'react'

const ConfirmDialogContext = createContext()

/**
 * Provider for setting a dialog component at the root level
 * of the application tree.  This is a workaround for issues
 * with nested dialogs in Chrome 52.  Positioning of the
 * dialog was causing it be clipped behind the orders element.
 *
 * @param {React.ComponentProps} [children] - The children of the provider
 * @returns React.Component
 */
const ConfirmDialogProvider = ({ children }) => {
  const [Component, setComponent] = useState(null)

  const openDialog = (component) => {
    setComponent(component)
  }

  const closeDialog = () => {
    setComponent(null)
  }

  return (
    <ConfirmDialogContext.Provider
      value={{
        openDialog,
        closeDialog,
        showDialog: !!Component,
        DialogComponent: () => Component,
      }}
    >
      {children}
    </ConfirmDialogContext.Provider>
  )
}

export { ConfirmDialogProvider }
export default ConfirmDialogContext
